import {Chip} from "@mui/material";
import {useEffect, useState} from "react";
import {MaterialSymbol} from "react-material-symbols";
import {useStopwatch} from "react-timer-hook";

interface ProblemTimerUIProps {
  startTime: Date;
  endTime?: Date;
}

function formatTime(hours: number, minutes: number, seconds: number): string {
  if (hours >= 1) {
    return "> 1 hour";
  }
  return `${minutes < 10 ? "0" + minutes : minutes} : ${seconds < 10 ? "0" + seconds : seconds}`;
}

export default function ProblemTimerUI({
  startTime,
  endTime,
}: ProblemTimerUIProps) {
  const [timerLabel, setTimerLabel] = useState("00 : 00");

  // Calculate time offset for stopwatch
  const stopwatchOffset = new Date();
  stopwatchOffset.setTime(
    stopwatchOffset.getTime() + (Date.now() - startTime.getTime()),
  );

  const {seconds, minutes, hours, isRunning, reset} = useStopwatch({
    autoStart: false,
  });

  useEffect(() => {
    const stopwatchOffset = new Date();
    if (endTime) {
      // If endTime exists, set the stopwatch to the endTime
      const timeDiff = endTime.getTime() - startTime.getTime();
      stopwatchOffset.setTime(stopwatchOffset.getTime() + timeDiff);
      reset(stopwatchOffset, false);
    } else {
      const timeDiff = Date.now() - startTime.getTime();
      stopwatchOffset.setTime(stopwatchOffset.getTime() + timeDiff);
      reset(stopwatchOffset, true);
    }
  }, [startTime, endTime]);

  useEffect(() => {
    setTimerLabel(formatTime(hours, minutes, seconds));
  }, [hours, seconds, minutes]);

  return (
    <Chip
      key="problem-timer"
      label={timerLabel}
      icon={
        <MaterialSymbol
          icon="timer"
          size={12}
          fill
          color="white"
          style={{marginLeft: "8px", marginRight: "-8px"}}
        />
      }
      sx={{
        height: "24px",
        borderRadius: "8px",
        backgroundColor: isRunning ? "black" : "secondary.dark",
        "& .MuiChip-label": {
          fontSize: "0.75rem",
          fontWeight: 600,
          color: isRunning ? "white" : "white",
        },
        "&:hover": {
          cursor: "default",
        },
      }}
    />
  );
}
